// extracted by mini-css-extract-plugin
export default {"text":"styles_text__kSyqA","button":"styles_button__ThWTs","icon":"styles_icon__2j6Xw","BookStage":"styles_BookStage__UzKw5"};